module.exports = __webpack_public_path__ + "img/hinge_300.a1482b5a.png";